module.exports = __webpack_public_path__ + "assets/car.711432cddc84f1b0c034760a79dea862a82316c93fd45176883e8b669bee6314.png";